import { render, staticRenderFns } from "./GalleryTab.vue?vue&type=template&id=3fdd6e5b&scoped=true"
import script from "./GalleryTab.vue?vue&type=script&lang=js"
export * from "./GalleryTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdd6e5b",
  null
  
)

export default component.exports